import React from 'react';
import PropTypes from 'prop-types';

const stackViewIcon = ({ className }) => (
  <svg
    className={className}
    width="56"
    height="53"
    viewBox="0 0 56 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2C1 1.44772 1.44772 1 2 1H53.3131C53.8654 1 54.3131 1.44772 54.3131 2V50.3499C54.3131 50.9022 53.8654 51.3499 53.3131 51.3499H2C1.44772 51.3499 1 50.9022 1 50.3499V10.5V2Z"
      fill="#fff"
      stroke="#1E1E1E"
      strokeWidth="2"
    />
    <rect
      x="19.0857"
      y="14.8098"
      width="16.5528"
      height="8.09822"
      rx="1.19018"
      fill="white"
      stroke="#1E1E1E"
      strokeWidth="1.61964"
    />
    <rect
      x="16.9475"
      y="18.8069"
      width="20.8286"
      height="11.3375"
      rx="1.19018"
      fill="white"
      stroke="#1E1E1E"
      strokeWidth="1.61964"
    />
    <rect
      x="14.8098"
      y="22.8557"
      width="25.1045"
      height="14.5768"
      rx="1.19018"
      fill="white"
      stroke="#1E1E1E"
      strokeWidth="1.61964"
    />
  </svg>
);

stackViewIcon.propTypes = {
  className: PropTypes.string
};

export default stackViewIcon;
